import { ApiService } from "@/services/ApiService";
import { useEffect, useState } from "react";
import Table from "@/components/Table";
import { t } from "i18next";
import { useAuth } from "@/contexts/Auth";
import { checkHasPermission } from "@/lib/permissions";
import ResourceDialog from "./ResourceDialog";

const Resource = () => {
  const [apiData, setApiData] = useState<any>([]);
  const { get } = ApiService;
  const { usuario } = useAuth();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedResource, setSelectedResource] = useState<any>(null);

  const columns = [
    {
      header: t("table.resource.head.nomeRecurso"),
      accessor: "nomeRecurso",
    },
    {
      header: t("table.resource.head.tipoRecurso"),
      accessor: "tipoRecursoFormatado",
    },
    {
      header: t("table.resource.status"),
      accessor: "status",
    }
  ];

  const allowedActions = [];
  if (checkHasPermission(usuario?.permissoes, "ROLE_RECURSO_EDITAR")) {
    allowedActions.push("editar");
  }
  if (checkHasPermission(usuario?.permissoes, "ROLE_RECURSO_DELETAR")) {
    allowedActions.push("remover");
  }

  const canAddNewResource = checkHasPermission(usuario?.permissoes, "ROLE_RECURSO_REGISTRAR");

  const fetchResources = async () => {
    try {
      const { data } = await get("api/v1/recurso/listar");

      const formatted = data.map((item: any) => ({
        ...item,
        tipoRecursoFormatado: t(`tipoRecurso.${item.tipoRecurso}`) || item.tipoRecurso,
      }));

      setApiData(formatted);
    } catch (error) {
      console.error("Erro ao buscar recursos", error);
    }
  };

  useEffect(() => {
    fetchResources();
  }, [get, t]);

  const handleCreate = () => {
    setSelectedResource(null);
    setIsModalOpen(true);
  };

  const handleEdit = (resource: any) => {
    setSelectedResource(resource);
    setIsModalOpen(true);
  };

  return (
    <div className="flex-1 overflow-hidden p-8 max-md:px-4">
      <div className="mb-8 border-b pb-4">
        <h1 className='text-3xl font-medium mb-8'>{t("ResourcePage.title")}</h1>
      </div>

      <ResourceDialog 
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        resourceToEdit={selectedResource}
        onSuccess={fetchResources}
      />

      {apiData && (
        <Table
          entity="recurso"
          baseRoute="api/v1/recurso"
          allowedActions={allowedActions}
          search={true}
          columns={columns}
          defaultData={apiData}
          buttonLabel={t("table.resource.btn.add")}
          onButtonClick={handleCreate}
          isButtonDisabled={!canAddNewResource}
          onEditAction={handleEdit}
          onRefresh={fetchResources}
        />
      )}
    </div>
  );
};

export default Resource;